import { render, staticRenderFns } from "./AddStep_PuYang_2.vue?vue&type=template&id=10954bc7&scoped=true&"
import script from "./AddStep_PuYang_2.vue?vue&type=script&lang=js&"
export * from "./AddStep_PuYang_2.vue?vue&type=script&lang=js&"
import style0 from "./AddStep_PuYang_2.vue?vue&type=style&index=0&id=10954bc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10954bc7",
  null
  
)

export default component.exports